import React, { useState, useEffect } from 'react';

import { FilePdfOutlined } from '@ant-design/icons';
import { Button, Spin, Table, message, Space } from 'antd';
import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

import AllegatoPreview from '../../CRM/AllegatoPreview';
import Configurazione from '../../Configurazione';
import sessionManager, { eVariableType } from '../../SessionManager';
import { GetErrorMessage } from '../../Utility';
import api from '../../api';
import { str } from '../../translations/stringres';
import FiltriMagazzino, { filtriFields } from '../FiltriMagazzino';
import HeaderBar from '../HeaderBar';

export default function DocumentiCliente(props: any) {
    const [isRunning, setIsunning] = useState(false);

    const [data, setData] = useState<any | null>(null);

    const [modalOpen, setModalOpen] = useState(false);
    const [idDocumento, setidDocumento] = useState(null);
    const [filtriMagazzino, setFiltriMagazzino] = useState<filtriFields>();

    useEffect(() => {
        if (filtriMagazzino != null) fetchData(filtriMagazzino);
    }, [props]);

    async function fetchData(e: filtriFields) {
        try {
            setIsunning(true);
            let querystring = '';
            querystring = querystring + 'idSocieta=' + Configurazione().idsocieta + '&';
            querystring = querystring + 'tipoDoc=' + props.tipoDocumento + '&';
            if (e?.dataInizio != null) querystring = querystring + 'dataInizio=' + e?.dataInizio?.toJSON() + '&';
            if (e?.dataFine != null) querystring = querystring + 'dataFine=' + e?.dataFine?.toJSON() + '&';

            const qs: string = Configurazione().apiBaseUrl + 'Documenti/DocumentiContoTerzi?' + querystring;

            const result = await api.get(qs);

            setData(result.data);
        } catch (error) {
            message.error(GetErrorMessage(error), 5);
        } finally {
            setIsunning(false);
        }
    }
    function onClickDownload(e: any) {
        try {
            setIsunning(true);

            setidDocumento(e.idDocumento);
        } catch (error) {
            message.error(GetErrorMessage(error), 5);
        } finally {
            setIsunning(false);
        }
    }
    const colsFattura: ColumnsType<any> = [
        { title: '', dataIndex: 'tipoDocumento', width: 10 },
        { title: str('numeroDocumento'), dataIndex: 'numeroDocumento', width: 30 },
        { title: str('gruppoDocumento'), dataIndex: 'gruppoDocumento', width: 60 },
        {
            title: str('dataDocumento'),
            dataIndex: 'dataDocumento',
            width: 125,
            render: (text) => (
                <div>
                    {new Date(text).toLocaleString(localStorage.getItem('codLingua')?.toString(), {
                        dateStyle: 'short',
                    })}
                </div>
            ),
        },
        { title: str('cliente'), dataIndex: 'cliente' },
        { title: str('descrizioneCodiceIva'), dataIndex: 'descrizioneCodiceIva', width: 300 },
        { title: str('totaleImponibile'), dataIndex: 'totaleImponibile', width: 300, align: 'right' },
        { title: str('totaleDocumento'), dataIndex: 'totaleDocumento', width: 175, align: 'right' },
        { title: str('codValuta'), dataIndex: 'codValuta', width: 80 },
        {
            title: '',
            dataIndex: 'download',
            width: 50,
            render: (record, text) => (
                <div>
                    <Button onClick={() => onClickDownload(text)} icon={<FilePdfOutlined />}></Button>
                </div>
            ),
        },
    ];
    const colsDDT: ColumnsType<any> = [
        { title: str('numeroDocumento'), dataIndex: 'numeroDocumento', width: 30 },
        { title: str('gruppoDocumento'), dataIndex: 'gruppoDocumento', width: 60 },
        {
            title: str('dataDocumento'),
            dataIndex: 'dataDocumento',
            width: 125,
            render: (text) => (
                <div>
                    {new Date(text).toLocaleString(localStorage.getItem('codLingua')?.toString(), {
                        dateStyle: 'short',
                    })}
                </div>
            ),
        },
        { title: str('cliente'), dataIndex: 'cliente', width: 450 },
        { title: str('indirizzo'), dataIndex: 'indirizzo' },
        {
            title: '',
            dataIndex: 'download',
            width: 50,
            render: (record, text) => (
                <div>
                    <Button onClick={() => onClickDownload(text)} icon={<FilePdfOutlined />}></Button>
                </div>
            ),
        },
    ];

    const closeModal = () => {
        setModalOpen(false);
        setidDocumento(null);
    };

    function onConfirmFiltri(e: filtriFields) {
        setFiltriMagazzino(e);
        fetchData(e);
    }

    return (
        <div style={{ marginTop: '0px' }}>
            <HeaderBar
                descrizione={props.tipoDocumento === 'C' ? 'Elenco DDT di Reso Conto Lavoro' : 'Elenco fatture'}
                menuSelezionato={props.tipoDocumento === 'C' ? 'Elenco DDT di Reso Conto Lavoro' : 'Elenco Fatture'}
            ></HeaderBar>

            <Space className="App-body" direction="vertical">
                <FiltriMagazzino
                    numeroBloccoVisible={false}
                    numeroBloccoFornitoreVisible={false}
                    fatturazioneVisible={false}
                    finituraVisible={false}
                    periodoVisible={true}
                    qualitaVisible={false}
                    onconfirm={(e: filtriFields) => onConfirmFiltri(e)}
                    params={null}
                    contoTerzi={true}
                    dataIni={dayjs().subtract(2, 'month')}
                ></FiltriMagazzino>
                <hr></hr>
                <Spin spinning={isRunning} size="large">
                    <Table
                        rowKey={'idDocumento'}
                        dataSource={data}
                        size="middle"
                        scroll={{ x: 'max-content' }}
                        columns={props.tipoDocumento === 'C' ? colsDDT : colsFattura}
                    ></Table>
                </Spin>
            </Space>

            <AllegatoPreview
                Open={modalOpen}
                onClose={closeModal}
                idAllegato={null}
                idDocumento={idDocumento}
                idSocieta={Configurazione().idsocieta}
                nomeFile={'Doc. ' + data?.numeroDocumento + ' ' + data?.dataDocumento}
            />
        </div>
    );
}
